import { PaymentGatewayType } from 'types/plansales/billing';
import { GroupPlanType } from 'types/plansales/plan';

export enum MemberType {
  NONE = 0,
  ADMIN = 1,
  COLLABORATOR = 2,
  EDITOR = 3,
  VIEWER = 4,
}

export type AccessibleGroup = {
  memberType: MemberType;
  groupId: string;
  groupName: string;
  planType: GroupPlanType;
  paymentGatewayType: PaymentGatewayType;
  invitedAt: string;
};

export type GetMemberClosetResponse = {
  accessibleGroups: AccessibleGroup[];
};

export type MemberCloset = GetMemberClosetResponse;
